export interface ILocalStoragePageInfo {
    presentationId: string | null;
    userId: string;
    knovioUserId: string;
    userName: string;
    userEmail: string;
    userChatName: string;
    jwtToken: string;
}

export type TLocalStoragePageInfo =
    'presentationId'
    | 'userId'
    | 'userName'
    | 'userEmail'
    | 'jwtToken'
    | 'userChatName'
    | 'knovioUserId';


const getStorageInfo = (id: string): ILocalStoragePageInfo => {
  const pageInfo = localStorage.getItem(id);
  return pageInfo ? JSON.parse(pageInfo) : null;
};

const setStorageProperty = (id: string, valueName: TLocalStoragePageInfo, value: string): void => {
  return localStorage.setItem(id, JSON.stringify({ ...getStorageInfo(id), [valueName]: value }));
};

const getStorageProperty = (id: string, valueName: TLocalStoragePageInfo): string | null => {
  return getStorageInfo(id)?.[valueName] || null;
};

const removeStorageValue = (id: string, valueName: TLocalStoragePageInfo): void => {
  if (!getStorageInfo(id) || !localStoragePageInfo.getStorageProperty(id, valueName)) return;
  const { [valueName]: removedItem, ...restValues } = getStorageInfo(id);
  return localStorage.setItem(id, JSON.stringify(restValues));
};


export const localStoragePageInfo = {
  getStorageInfo,
  setStorageProperty,
  getStorageProperty,
  removeStorageValue
};
